module.exports = {
    API_URL: 'https://api.ondecentral.com',
    INFURA_KEY : '1235e2b46885432d8fa2f309e8f27dd8'
}